import { meter } from "./metrics";

export const isSplunkNpeTelemetryEnabled =
  process.env.SPLUNK_NPE_TELEMETRY_ENABLED === "true";

export const isNpeEnabled = process.env.IS_NPE === "true";

export const areOtelMetricsEnabled =
  isNpeEnabled && isSplunkNpeTelemetryEnabled;

export const areMetricsEnabledClientSide = () => {
  // In order to not have another env variable - one that would have to be client side
  // and therefore would require a separate build because we don't want the old
  // site to do telemetry, we are checking if the meter is a NoopMeter - bc if it is, then
  // we are not in a telemetry enabled environment - aka we are in the old site, not NPE
  const isMeterNotDefined =
    Object.getPrototypeOf(meter).constructor.name === "NoopMeter";
  return !isMeterNotDefined;
};
